import * as React from 'react';
import './_infobubblelink.scss';
import { setInnerHtml } from 'sos-common/js/utils/helpers';
import { hashCode } from 'sos-common/js/utils/hash';
import { Icon } from 'sos-common/js/components/Icon/icon';
import { KeyboardEventKeys } from 'sos-common/js/utils/keyboardEventKeys';

interface InfoBubbleLinkProps {
  linktext: string;
  content: string;
}

interface LinkCoordinates {
  top: number;
  left: number;
}

interface InfoBubbleLinkState {}

export class InfoBubbleLink extends React.Component<InfoBubbleLinkProps, InfoBubbleLinkState> {
  private _buttonRef: React.RefObject<HTMLButtonElement>;
  private _id: string;

  constructor(props: InfoBubbleLinkProps) {
    super(props);
    this._buttonRef = React.createRef();
    this._id = hashCode(props.linktext);
    this.state = {};
  }

  getElementCoords = (elem: HTMLElement): LinkCoordinates => {
    var box = elem.getBoundingClientRect();

    var body = document.body;
    var docEl = document.documentElement;

    var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

    var clientTop = docEl.clientTop || body.clientTop || 0;
    var clientLeft = docEl.clientLeft || body.clientLeft || 0;

    var top = box.top + scrollTop - clientTop;
    var left = box.left + scrollLeft - clientLeft;

    return { top: Math.round(top), left: Math.round(left) };
  };

  componentDidMount = () => {};

  click = (e: React.SyntheticEvent<HTMLButtonElement>) => {
    const livearea = document.getElementById('livearea');
    if (!livearea) {
      console.error('Element with id "livearea" missing. This container element needs to have role="status".');
      return;
    }

    // Bubble
    let bubble = document.createElement('div');
    bubble.className = 'infobubblelink__bubble';
    bubble.innerHTML = this.props.content;
    bubble.id = this._id;
    bubble.setAttribute('tabindex', '-1');
    livearea.appendChild(bubble);
    bubble.focus({ preventScroll: true });

    // Close button
    let closeBtn = document.createElement('button');
    closeBtn.className = 'infobubblelink__close';
    closeBtn.setAttribute('aria-label', 'Stäng');
    bubble.appendChild(closeBtn);

    let coordinates = this.getElementCoords(this._buttonRef.current);

    // Bubble position
    let top = coordinates.top + this._buttonRef.current.clientHeight + 10;
    let left = coordinates.left + this._buttonRef.current.clientWidth / 2 - bubble.clientWidth / 2;
    bubble.style.top = top + 'px';
    bubble.style.left = left + 'px';

    // Backdrop
    let backdrop = document.createElement('div');
    backdrop.className = 'infobubblelink__backdrop';
    backdrop.id = 'backdrop' + this._id;
    document.body.appendChild(backdrop);

    // Backdrop click
    backdrop.addEventListener('click', () => {
      closeBubble();
    });

    // Close button click
    closeBtn.addEventListener('click', () => {
      closeBubble();
    });

    let isAvailableInDom = document.getElementById(backdrop.id);
    if (isAvailableInDom) {
      document.addEventListener('keyup', (e) => {
        if (e.key === KeyboardEventKeys.esc) {
          closeBubble();
        }
      });
    }

    const closeBubble = () => {
      document.body.removeChild(backdrop);
      livearea.removeChild(bubble);
      this._buttonRef.current.focus({ preventScroll: true });
    };
  };

  public render() {
    const { linktext } = this.props;
    return (
      <button ref={this._buttonRef} onClick={this.click} className="infobubblelink">
        {linktext}
      </button>
    );
  }
}
